import React, { FC, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useAlert } from 'react-alert'
import {
  updateMailDelivery,
} from '../../../states/containers/setting/systemSlice'
import { useTranslation } from 'react-i18next'
import { RootState } from '../../../states/containers/store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconName } from '@fortawesome/fontawesome-common-types'
import LoadingSquare from '../common/LoadingSquare'

const MailDelivery: FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const alert = useAlert()

  const {
    system,
    login,
  } = useSelector((state: RootState) => (state))

  const [customAlert, setCustomAlert] = useState<boolean>(true)
  const [workStyleAlert, setWorkStyleAlert] = useState<boolean>(true)
  const [notStarted, setNotStarted] = useState<boolean>(true)
  const [mailMagazine, setMailMagazine] = useState<boolean>(true)
  const [newReport, setNewReport] = useState<boolean>(true)
  const [approval, setApproval] = useState<boolean>(true)

  useEffect(() => {
    setCustomAlert(!!system.mail_delivery?.custom_alert)
    setWorkStyleAlert(!!system.mail_delivery?.work_style_alert)
    setNotStarted(!!system.mail_delivery?.not_started)
    setMailMagazine(!!system.mail_delivery?.mail_magazine)
    setNewReport(!!system.mail_delivery?.new_report)
    setApproval(!!system.mail_delivery?.approval)
  }, [system.mail_delivery])

  const handleMailSubmit = () => {
    if (!system.mail_delivery) return
    dispatch(
      updateMailDelivery(
        {
          ...system.mail_delivery,
          not_started: notStarted,
          work_style_alert: workStyleAlert,
          custom_alert: login.function_enabled_state?.organizational_analysis ? customAlert : true,
          mail_magazine: mailMagazine,
          new_report: login.function_enabled_state?.ai_work_assessment ? newReport : true,
          approval: login.function_enabled_state?.task_management_approval ? approval : true,
        },
        () => {
          alert.success(t('form.alert.updated'))
        },
      ),
    )
  }

  return (
    <>
      {
        system.isLoading ? (
          <LoadingSquare>
            <>
              設定を読み込んでいます…
            </>
          </LoadingSquare>
        ) : (
          <>
            <div
              className={`graphical_check_box${notStarted ? " selected" : ""}`}
              onClick={() => setNotStarted(!notStarted)}
              role="none"
            >
              <FontAwesomeIcon
                icon={['far', `${notStarted ? 'check-square' : 'square'}` as IconName]}
                className={`icon ${notStarted ? "checked" : "no_check"}`}
              />
              <div>
                <div className="check_box_title">
                  {t(`setting.system.mail_delivery.not_started_enabled`)}
                </div>
                <div className="check_box_description">
                  QaseeClientが未起動のユーザーがいた時、あなたに未起動ユーザーをお知らせするメールを送信しています
                </div>
              </div>
            </div>
            {
              login.function_enabled_state?.organizational_analysis && (
                <div
                  className={`graphical_check_box${customAlert ? " selected" : ""}`}
                  onClick={() => setCustomAlert(!customAlert)}
                  role="none"
                >
                  <FontAwesomeIcon
                    icon={['far', `${customAlert ? 'check-square' : 'square'}` as IconName]}
                    className={`icon ${customAlert ? "checked" : "no_check"}`}
                  />
                  <div>
                    <div className="check_box_title">
                      {t(`setting.system.mail_delivery.custom_alert_enabled`)}
                    </div>
                    <div className="check_box_description">
                      カスタムアラートに設定した条件に合致した時、あなたにカスタムアラートの情報メールを送信しています
                    </div>
                  </div>
                </div>
              )
            }
            <div
              className={`graphical_check_box${mailMagazine ? " selected" : ""}`}
              onClick={() => setMailMagazine(!mailMagazine)}
              role="none"
            >
              <FontAwesomeIcon
                icon={['far', `${mailMagazine ? 'check-square' : 'square'}` as IconName]}
                className={`icon ${mailMagazine ? "checked" : "no_check"}`}
              />
              <div>
                <div className="check_box_title">
                  {t('setting.system.mail_delivery.mail_magazine_enabled')}
                </div>
                <div className="check_box_description">
                  Qaseeの操作に役立つメールマガジンをお送りしています
                </div>
              </div>
            </div>
            {
              login.function_enabled_state?.ai_work_assessment && (
                <div
                  className={`graphical_check_box${newReport ? " selected" : ""}`}
                  onClick={() => setNewReport(!newReport)}
                  role="none"
                >
                  <FontAwesomeIcon
                    icon={['far', `${newReport ? 'check-square' : 'square'}` as IconName]}
                    className={`icon ${newReport ? "checked" : "no_check"}`}
                  />
                  <div>
                    <div className="check_box_title">
                      {t('setting.system.mail_delivery.new_report_enabled')}
                    </div>
                    <div className="check_box_description">
                      新しいレポートが発行された時、あなたにレポート発行通知メールを送信しています
                    </div>
                  </div>
                </div>
              )
            }
            {
              login.function_enabled_state?.task_management_approval && (
                <div
                  className={`graphical_check_box${approval ? " selected" : ""}`}
                  onClick={() => setApproval(!approval)}
                  role="none"
                >
                  <FontAwesomeIcon
                    icon={['far', `${approval ? 'check-square' : 'square'}` as IconName]}
                    className={`icon ${approval ? "checked" : "no_check"}`}
                  />
                  <div>
                    <div className="check_box_title">
                      申請・承認お知らせメールを受信する
                    </div>
                    <div className="check_box_description">
                      あなたに関係する申請および承認時、あなたにお知らせメールを送信しています
                    </div>
                  </div>
                </div>
              )
            }
            <button
              type="button"
              className="mt-4 button"
              onClick={handleMailSubmit}
            >
              {t('setting.system.mail_delivery.submit')}
            </button>
          </>
        )
      }
    </>
  )
}

export default MailDelivery
